var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vs-sidebar',_vm._g(_vm._b({ref:"sidebar",staticClass:"items-no-padding",attrs:{"parent":"#expenses-app"},model:{value:(_vm.isActive),callback:function ($$v) {_vm.isActive=$$v},expression:"isActive"}},'vs-sidebar',_vm.$attrs,false),_vm.$listeners),[_c('vx-main-sidebar',{attrs:{"menu-routes":_vm.menuRoutes}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }